export const SITE_SERIAL_NUMBER_REGEX = /^[A-Z]{2}-[A-Za-z0-9]{3}(?:-[0-9]{2})?$/;
export const SITE_SERIAL_NUMBER_FORMAT_MESSAGE = 'Serial number must follow the format CC-SSS (e.g., DK-Fou)';
